<template>
  <div class="copyable-text-container">
    <a-typography-paragraph
      :copyable="{ text: copyText, tooltips: false }"
      class="copyable-paragraph"
      :class="{ absolute }"
    >
      <template #copyableIcon="{ copied }">
        <CopyOutlined v-if="!copied" key="copy-icon" class="copy-icon" />

        <CheckCircleOutlined v-else key="copied-icon" class="copy-icon" />
      </template>

      <template #copyableTooltip="{ copied }">
        <span v-if="!copied" key="copy-tooltip">
          Нажмите, чтобы скопировать
        </span>

        <span v-else key="copied-tooltip">Значение скопировано!</span>
      </template>

      <slot>
        <template v-if="props.text">{{ props.text }}</template>
      </slot>
    </a-typography-paragraph>
  </div>
</template>

<script setup lang="ts">
import { CopyOutlined, CheckCircleOutlined } from "@ant-design/icons-vue";
import { computed } from "vue";

const props = defineProps<{
  text?: string | null;
  copyText?: string;
  absolute?: boolean;
}>();

const copyText = computed(() => props.copyText ?? props.text ?? "");
</script>

<style scoped lang="scss">
.copyable-text-container {
  position: relative;
  display: inline-block;

  .copyable-paragraph {
    line-height: 115%;
  }

  .ant-typography {
    margin-bottom: 0;
  }

  .copyable-paragraph {
    color: inherit;

    :deep(.ant-typography-copy) {
      visibility: hidden;
    }

    &.absolute {
      transform: translateX(8px);
    }
  }

  :deep(.ant-typography-copy) {
    color: var(--color-primary);
  }

  &:hover {
    .copyable-paragraph {
      :deep(.ant-typography-copy) {
        visibility: visible;
      }
    }
  }
}
</style>
